

































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AvaliacaoRiscoApaStore from '@/components/AvaliacaoRiscoApa/Store/AvaliacaoRiscoApaStore'
import EventBus from '@/plugins/EventBus'
import AgendamentoApi from '@/Apis/Agendamento/Services/AgendamentoApi'
import { IniciaApa } from '@/types/interfaces/IniciaApa'

@Component
export default class ModalAvaliacaoRiscoApa extends Vue {
  @Prop({ type: Boolean, required: true }) visible!: boolean
  @Prop({ required: true }) solicitacao: any

  showModal: boolean = false
  showSend: boolean = false
  solicitationId: string = ''
  apaId: string = ''
  linkQuest: string = ''
  notificacaoEnviada: boolean = false
  statusCirurgia: string = ''
  dataCirurgia: string | null = null
  loadingSendState: boolean = false
  urlBase = 'https://www.portalfinx.com.br/v2/backoffice/redirect'


  @Emit('close')
  closeModal() {
    this.showModal = false
  }

  esc() {
    this.closeModal()
  }

  get loadingSend() {
    return this.loadingSendState
  }

  set loadingSend(value: boolean) {
    this.loadingSendState = value
  }

  get showAvaliacaoResumo() {
    if (this.apaId) {
      return true
    }
    return false
  }

  get showCopy() {
    if (
      this.solicitacao.apa
      && this.solicitacao.apa.linkQuestionario
      && !this.solicitacao.apa.id
    ) {
      return true
    }
    return false
  }

  get getLink() {
    if (this.solicitacao.apa && this.solicitacao.apa.linkQuestionario) {
      return `${this.urlBase}${this.solicitacao.apa.linkQuestionario}`
    }
    return ''
  }

  async copyLink() {
    await navigator.clipboard.writeText(`${this.urlBase}${this.solicitacao.apa.linkQuestionario}`)
  }

  async sendMessageApa() {
    if (!this.showSend) {
      return
    }
    try {
      this.loadingSend = true
      const iniciaApaPayload: IniciaApa = {
        solicitacaoId: this.solicitationId,
        hospitalId: this.solicitacao.hospitalId,
        medicoSolicitanteId: this.solicitacao.medicoSolicitanteId,
        updateController: true,
        dataCirurgia: new Date(this.solicitacao.dataAgendamento),
        carater: this.solicitacao.carater.key,
        apaParam: this.solicitacao.apa,
      }

      const resultApa = await AgendamentoApi.postIniciaApa(
        this.solicitationId,
        iniciaApaPayload,
      )

      if (resultApa.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Menssagem em processo de envio.',
          icon: 'done',
          color: '#2E7D32',
        })
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Houve um erro ao realizar o envio.',
          icon: 'warning',
          color: '#C62828',
        })
      }
    } catch (error) {
      this.loadingSend = false
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Houve um erro ao realizar o envio.',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.loadingSend = false
    }
  }

  resetData() {
    this.dataCirurgia = null
    this.apaId = ''
    this.notificacaoEnviada = false
    this.solicitationId = ''
    this.statusCirurgia = ''
    this.linkQuest = ''
    this.showSend = false
  }

  getDataSolicitacao() {
    this.resetData()
    this.solicitationId = this.solicitacao.id
    this.statusCirurgia = this.solicitacao.statusCirurgia
    this.dataCirurgia = this.solicitacao.dataAgendamento || null
    this.apaId = this.solicitacao.apa.id || ''
    this.linkQuest = this.solicitacao.apa.linlinkQuestionario || ''
    this.notificacaoEnviada = this.solicitacao.apa.notificacaoEnviada || false
  }

  daysToSurgery() {
    let interval = 0
    let diasAteCirurgia = 0
    if (this.dataCirurgia) {
      interval = new Date(this.dataCirurgia).getTime() - new Date().getTime()
      diasAteCirurgia = Math.floor(interval / (1000 * 60 * 60 * 24))
    }
    if (!this.solicitacao.apa.notificacaoEnviada && diasAteCirurgia >= 0) {
      this.showSend = true
    } else {
      this.showSend = false
    }
  }

  get getAvaliacaoRiscoApaStore() {
    return getModule(AvaliacaoRiscoApaStore, this.$store)
  }

  get laudos() {
    return this.getAvaliacaoRiscoApaStore.arquivos || []
  }

  @Watch('visible')
  async onChangeShowModal(visible: boolean) {
    try {
      if (visible) {
        this.$emit('loadingAvaliacaoRiscoApa', true)
        this.getDataSolicitacao()
        this.daysToSurgery()
        if (this.apaId !== '') {
          await this.getAvaliacaoRiscoApaStore.getAvaliacao({
            paramId: this.apaId,
          })
        }
        await this.getAvaliacaoRiscoApaStore.getArquivosAvaliacaoRiscoPreOperatoria(
          this.solicitationId,
        )
        this.showModal = true
      } else {
        this.showModal = false
        this.getAvaliacaoRiscoApaStore.resetAvaliacaoRiscoApa()
      }
    } catch (error) {
      this.showModal = false
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao carregar a avaliação pré-operatória',
        icon: 'warning',
        color: '#C62828',
      })
    } finally {
      this.$emit('loadingAvaliacaoRiscoApa', false)
    }
  }
}
